import * as React from 'react';
import './App.css';
import {
  Route,
  Switch,
  BrowserRouter,
} from "react-router-dom";
import withRoot from './withRoot';
import Home from "./components/home/Home";
import Basket from "./components/basket/Basket";
import MyAccount from "./components/myaccount/MyAccount";
import Wishlist from "./components/wishlist/Wishlist";
import ProductCatalog from "./components/product/ProductCatalog";
import ProductDetail from "./components/product/ProductDetail";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Checkout from "./components/checkout/Checkout";
import ResponsiveDialog from "./components/home/Dialog";
import CustomerData from './data/CustomerData.json'
import {IProduct, IQuantity, IUser} from "./functions/Interfaces";
import {Helmet} from "react-helmet";
import {makeBridgeString, makeBridgeStringBool, makeBridgeStringObject, getUserInfoString, getSharingString} from './functions/WebbridgeFunctions';
import SearchResults from './components/searchresult/SearchResults';
import NotFound from './components/notfound/NotFound';
import Category from './components/categories/Category';


// Hauptkomponente des Demo-Shops

class App extends React.Component<
  any,
  {
    data: IProduct[];
    dataInBasket: IProduct[];
    sizeBasket: number;
    basketQuantity: IQuantity[];
    dataInWishlist: IProduct[];
    sizeWishlist: number;
    wishQuantity: IQuantity[];
    login: boolean;
    customer: IUser;
    title: string;
    isOpenDialog: boolean;
    error: any;
  }
> {
  public testCustomers: IUser[] = CustomerData;
  public mounted : boolean = false;

  constructor(props: any) {
    super(props);

    // Bind the this context to the handler functions
    // Basket
    this.handlerAdd = this.handlerAdd.bind(this);
    this.handlerClear = this.handlerClear.bind(this);
    this.handlerDeleteProduct = this.handlerDeleteProduct.bind(this);

    // Wishlist
    this.handlerAddWish = this.handlerAddWish.bind(this);
    this.handlerClearWish = this.handlerClearWish.bind(this);
    this.handlerDeleteWish = this.handlerDeleteWish.bind(this);

    // Login
    this.handlerLogin = this.handlerLogin.bind(this);

    // Update
    this.handlerUpdate = this.handlerUpdate.bind(this);

    // State of the App Component
    this.state = {
      data: [],
      dataInBasket: [],
      sizeBasket: 0,
      basketQuantity: [],
      dataInWishlist: [],
      sizeWishlist: 0,
      wishQuantity: [],
      login: false,
      customer: this.testCustomers[1],
      title: "Digital Excellence",
      isOpenDialog: false,
      error: null
    };
  }

  public toggleDialog = () => {
    if (this.mounted) {
      this.setState({
        isOpenDialog: !this.state.isOpenDialog
      });
    }
  };

  public componentDidMount() {
    this.mounted = true;
    const APIPROD = "https://demo-shop-api.aac.ninja/v1/products";
    this.updateStateWithLocalStorage();
    window.addEventListener("popstate", this.handlerUpdate);

    fetch(APIPROD)
      .then(response => response.json())
      .then(data => {
        if (this.mounted) {
          this.setState({ data: data.products})
        }}
      )
      .catch(error => {
        if (this.mounted) {
          this.setState({error})
        }
        });
  }

   public componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener(
      "popstate", this.handlerUpdate
    );
  }

  
  // Updates the total State with the LocalStorage
  public updateStateWithLocalStorage(): void {
    let dataInBasket: IProduct[] = [];
    let sizeBasket: number = 0;
    let basketQuantity: IQuantity[] = [];
    let dataInWishlist: IProduct[] = [];
    let sizeWishlist: number = 0;
    let wishQuantity: IQuantity[] = [];
    let login: boolean = false;
    let customer: IUser = this.testCustomers[0];
    let title: string = "Digital Excellence";

    dataInBasket = this.getLocalStorageObject("dataInBasket");
    sizeBasket = this.getLocalStorageNumber("sizeBasket");
    basketQuantity = this.getLocalStorageObject("basketQuantity");

    dataInWishlist = this.getLocalStorageObject("dataInWishlist");
    sizeWishlist = this.getLocalStorageNumber("sizeWishlist");
    wishQuantity = this.getLocalStorageObject("wishQuantity");

    if (localStorage.hasOwnProperty("login")) {
      const lc: any = localStorage.getItem("login");
      if (lc !== null) {
        login = lc.includes("true") ? true : false;
      }
    }

    customer = this.getLocalStorageObject("customer");

    if (localStorage.hasOwnProperty("title")) {
      const lc: any = localStorage.getItem("title");
      if (lc !== null) {
        title = lc;
      }
    }
    if (this.mounted) {
      this.setState ({
        dataInBasket,
        sizeBasket,
        basketQuantity,
        dataInWishlist,
        sizeWishlist,
        wishQuantity,
        login,
        customer,
        title
      });
    }
  }

  public getLocalStorageObject(input: string): any {
    if (localStorage.hasOwnProperty(input)) {
      const lc: any = localStorage.getItem(input);
      if (lc !== null) {
        return JSON.parse(lc);
      } else {
        return [];
      }
    } else {
      return [];
    }
  }

  public getLocalStorageNumber(input: string): number {
    if (localStorage.hasOwnProperty(input)) {
      const lc: any = localStorage.getItem(input);
      if (lc !== null) {
        return +lc;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  public getBasketFromLocalStorage(): any {
    let dataInBasket: IProduct[] = [];
    let sizeBasket: number = 0;
    let basketQuantity: IQuantity[] = [];

    dataInBasket = this.getLocalStorageObject("dataInBasket");
    sizeBasket = this.getLocalStorageNumber("sizeBasket");
    basketQuantity = this.getLocalStorageObject("basketQuantity");

    return [sizeBasket, dataInBasket, basketQuantity];
  }

  public getWishFromLocalStorage(): any {
    let dataInWishlist: IProduct[] = [];
    let sizeWishlist: number = 0;
    let wishQuantity: IQuantity[] = [];

    dataInWishlist = this.getLocalStorageObject("dataInWishlist");
    sizeWishlist = this.getLocalStorageNumber("sizeWishlist");
    wishQuantity = this.getLocalStorageObject("wishQuantity");

    return [sizeWishlist, dataInWishlist, wishQuantity];
  }

  public getUserFromLocalStorage(): any {
    let login: boolean = false;
    let customer: IUser = this.testCustomers[0];

    if (localStorage.hasOwnProperty("login")) {
      const lc: any = localStorage.getItem("login");
      if (lc !== null) {
        login = lc.includes("true") ? true : false;
      }
    }
    customer = this.getLocalStorageObject("customer");

    return [login, customer];
  }

  public setBasketToLocalStorage(
    sizeBasket: number,
    dataInBasket: IProduct[],
    basketQuantity: IQuantity[]
  ): void {
    localStorage.setItem("sizeBasket", sizeBasket.toString());
    localStorage.setItem("dataInBasket", JSON.stringify(dataInBasket));
    localStorage.setItem("basketQuantity", JSON.stringify(basketQuantity));
  }

  public setWishToLocalStorage(
    sizeWishlist: number,
    dataInWishlist: IProduct[],
    wishQuantity: IQuantity[]
  ): void {
    localStorage.setItem("sizeWishlist", sizeWishlist.toString());
    localStorage.setItem("dataInWishlist", JSON.stringify(dataInWishlist));
    localStorage.setItem("wishQuantity", JSON.stringify(wishQuantity));
  }

  public handlerLogin = (email: string, password: string) => {
    let login: boolean = false;
    let customer: IUser = this.testCustomers[0];

    if (localStorage.hasOwnProperty("login")) {
      const lc: any = localStorage.getItem("login");
      if (lc !== null) {
        login = lc.includes("true") ? true : false;
      }
    }

    this.testCustomers.forEach((testCustomer: IUser) => {
      if (email === testCustomer.email && password === testCustomer.password) {
        login = true;
        customer = testCustomer;
      }
    });
    localStorage.setItem("login", login.toString());
    localStorage.setItem("customer", JSON.stringify(customer));

    this.updateStateWithLocalStorage();
  };

  public handlerLogout = () => {
    const login: boolean = false;
    localStorage.setItem("login", login.toString());
    this.updateStateWithLocalStorage();
  };

  // Adds a product to the Basket
  public handlerAdd = (product: IProduct) => {
    const storage: any[] = this.getBasketFromLocalStorage();
    let sizeBasket: number = storage[0];
    let dataInBasket: IProduct[] = storage[1];
    let basketQuantity: IQuantity[] = storage[2];

    sizeBasket = sizeBasket + 1;
    const found: any = dataInBasket.find(item => item.id === product.id);
    if (found === undefined) {
      dataInBasket = dataInBasket.concat(product);
    }

    basketQuantity = this.addQuantity(basketQuantity, product.id);
    this.setBasketToLocalStorage(sizeBasket, dataInBasket, basketQuantity);
    this.updateStateWithLocalStorage();
  };

  // Adds a product to the Wishlist
  public handlerAddWish = (product: IProduct) => {
    const storage: any[] = this.getWishFromLocalStorage();
    let sizeWishlist: number = storage[0];
    let dataInWishlist: IProduct[] = storage[1];
    let wishQuantity: IQuantity[] = storage[2];

    sizeWishlist = sizeWishlist + 1;
    // const found : IProduct = dataInWishlist.find(item => item.id === product.id)
    const found: any = dataInWishlist.find(item => item.id === product.id);
    if (found === undefined) {
      dataInWishlist = dataInWishlist.concat(product);
    }
    wishQuantity = this.addQuantity(wishQuantity, product.id);
    this.setWishToLocalStorage(sizeWishlist, dataInWishlist, wishQuantity);
    this.updateStateWithLocalStorage();
  };

  public handlerDeleteProduct = (product: IProduct) => {
    const storage: any[] = this.getBasketFromLocalStorage();
    let sizeBasket: number = storage[0];
    let dataInBasket: IProduct[] = storage[1];
    let basketQuantity: IQuantity[] = storage[2];

    // const elem : IQuantity = basketQuantity.find(item => item.id === product.id);
    const elem: any = basketQuantity.find(item => item.id === product.id);
    if (elem !== undefined) {
      sizeBasket = sizeBasket - elem.quantity;
      dataInBasket = dataInBasket.filter(item => item.id !== product.id);
      basketQuantity = basketQuantity.filter(item => item.id !== product.id);
    }
    this.setBasketToLocalStorage(sizeBasket, dataInBasket, basketQuantity);
    this.updateStateWithLocalStorage();
  };

  public handlerDeleteWish = (product: IProduct) => {
    const storage: any[] = this.getWishFromLocalStorage();
    let sizeWishlist: number = storage[0];
    let dataInWishlist: IProduct[] = storage[1];
    let wishQuantity: IQuantity[] = storage[2];

    // const elem : IQuantity = wishQuantity.find(item => item.id === product.id);
    const elem: any = wishQuantity.find(item => item.id === product.id);
    if (elem !== undefined) {
      sizeWishlist = sizeWishlist - elem.quantity;
      dataInWishlist = dataInWishlist.filter(item => item.id !== product.id);
      wishQuantity = wishQuantity.filter(item => item.id !== product.id);
    }
    this.setWishToLocalStorage(sizeWishlist, dataInWishlist, wishQuantity);
    this.updateStateWithLocalStorage();
  };

  public handlerClear = () => {
    if (this.mounted) {
      this.setState({ dataInBasket: [], sizeBasket: 0, basketQuantity: [] });
      this.setBasketToLocalStorage(0, [], []);
    }
  };

  public handlerClearWish = () => {
    if (this.mounted) {
      this.setState({ dataInWishlist: [], sizeWishlist: 0, wishQuantity: [] });
      this.setWishToLocalStorage(0, [], []);
    }
  };

  public handlerTitle = (title: string) => {
    if (this.mounted) {
      this.setState({ title });
      localStorage.setItem("login", title);
    }
  };

  public setHeaderPurchase = () => {
    const bridgepurchase: string = makeBridgeString("purchase", "true");
    return (
      <Helmet>
        <script>{bridgepurchase}</script>
      </Helmet>
    );
  };

  public handlerUpdate = () => {
      this.forceUpdate();
       // location.reload();
  };

  public render() {
    const storageBasket: any[] = this.getBasketFromLocalStorage();
    const sizeBasket: number = storageBasket[0];
    const dataInBasket: IProduct[] = storageBasket[1];
    const basketQuantity: IQuantity[] = storageBasket[2];
    const storageWish: any[] = this.getWishFromLocalStorage();
    const sizeWishlist: number = storageWish[0];
    const dataInWishlist: IProduct[] = storageWish[1];
    const wishQuantity: IQuantity[] = storageWish[2];
    const storageUser: any[] = this.getUserFromLocalStorage();
    const login: boolean = storageUser[0];
    const customer: IUser = storageUser[1];

    const link: string = window.location.href;

    // Fehlerfall API konnte nicht geladen werden -> Besser möglich?
    if(this.state.error) {

      return (
        <BrowserRouter>
          <div className="App">
            <Header {...{ sizeBasket, sizeWishlist }} />
            <main>
              <div className="content">
              <p>{this.state.error.message}</p>
              </div>
            </main>
            <Footer/>
            <div className="push"/>
          </div>
        </BrowserRouter>
      );
    } 

    return (
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <div className="App">
          <Header {...{ sizeBasket, sizeWishlist }} />
          <main> {
             setHeader(
                this.state.sizeBasket,
                this.state.sizeWishlist,
                this.state.login,
                this.state.customer
              )
             }
             {setSharingHeader(this.state.data, link)}
            {setTitleHeader(this.state.data, link)}
            <div className="content">
              <Switch>
                <Route
                  exact={true}
                  path="/"
                  render={() => <Home actionUpdate={this.handlerUpdate} />}
                />
                <Route
                  exact={true}
                  path="/wishlist"
                  render={() => (
                    <Wishlist
                      products={dataInWishlist}
                      size={sizeWishlist}
                      quantity={wishQuantity}
                      actionClear={this.handlerClearWish}
                      actionDelete={this.handlerDeleteWish}
                      actionUp = {this.handlerUpdate}
                    />
                  )}
                />
                <Route
                  exact={true}
                  path="/basket"
                  render={() => (
                    <Basket
                      products={dataInBasket}
                      size={sizeBasket}
                      quantity={basketQuantity}
                      login={login}
                      actionClear={this.handlerClear}
                      actionDelete={this.handlerDeleteProduct}
                      actionUp = {this.handlerUpdate}
                    />
                  )}
                />
                <Route
                  exact={true}
                  path="/myaccount"
                  render={() => (
                    <MyAccount
                      login={login}
                      checkLogin={this.handlerLogin}
                      actionLogout={this.handlerLogout}
                      actionUpdate = {this.handlerUpdate}
                      customer={customer}
                    />
                  )}
                />
                <Route
                  exact={true}
                  path="/products"
                  render={() => (
                    <ProductCatalog
                      products={this.state.data}
                      actionUpdate={this.handlerUpdate}
                    />
                  )}
                />
                <Route
                  path="/p/"
                  render={() => (
                    <ProductDetail
                      products={this.state.data}
                      actionAddB={this.handlerAdd}
                      actionAddW={this.handlerAddWish}
                      actionUpdate={this.handlerUpdate}
                    />
                  )}
                />
                <Route
                  path="/checkout"
                  render={() => (
                    <Checkout
                      products={dataInBasket}
                      quantity={basketQuantity}
                      customer={customer}
                      actionClear={this.handlerClear}
                    />
                  )}
                />
                <Route
                  path="/search/"
                  render={() => (
                    <SearchResults
                      products={this.state.data}
                      actionUpdate={this.handlerUpdate}
                    />
                  )}
                />
                <Route
                  path="/woman"
                  render={() => (
                    <Category
                      products={this.state.data}
                      keyword={"women"}
                      actionUpdate={this.handlerUpdate}
                    />
                  )}
                />
                <Route
                  path="/man"
                  render={() => (
                    <Category
                      products={this.state.data}
                      keyword={"men"}
                      actionUpdate={this.handlerUpdate}
                    />
                  )}
                />
                <Route component={NotFound} />
              </Switch>
              <ResponsiveDialog />
              <div className="push" />
            </div>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }

  private addQuantity(inQuantity: IQuantity[], id: string): IQuantity[] {
    const dummyQuantity: any = inQuantity.find(item => item.id === id);
    let resQuantity: IQuantity[] = [];
    if (dummyQuantity !== undefined) {
      // const quantityElem : IQuantity = inQuantity.find(item => item.id === id);
      // if(quantityElem !== undefined) {
      resQuantity = inQuantity.map((item: IQuantity) => {
        if (item.id === id) {
          item.quantity = item.quantity + 1;
        }
        return item;
      });
    } else {
      const elem: IQuantity = { id, quantity: 1 };
      resQuantity = inQuantity.concat(elem);
    }
    return resQuantity;
  }
} export default withRoot(App);

  function setHeader(basket: number, wishlist: number, login: boolean, customer: IUser) {
    // Basket
    const basketString: string = basket.toString();
    const bridgeBasket = makeBridgeString("basket", basketString);
    // Wishlist
    const wishlistString: string = wishlist.toString();
    const bridgeWishlist = makeBridgeString("wishlist", wishlistString);
    // Login
    const loginString: string = login.toString();
    const bridgeLogin = makeBridgeStringBool("login", loginString);

    // Customer information
    const customerString: string = getUserInfoString(customer);
    const bridgeCustomer: string = makeBridgeStringObject(
      "userInfo",
      customerString
    );

    if (login) {
      return (
        <Helmet>
          <script>{bridgeBasket}</script>
          <script>{bridgeWishlist}</script>
          <script>{bridgeLogin}</script>
          <script>{bridgeCustomer}</script>
        </Helmet>
      );
    } else {
      return (
        <Helmet>
          <script>{bridgeBasket}</script>
          <script>{bridgeWishlist}</script>
          <script>{bridgeLogin}</script>
        </Helmet>
      );
    }
  }
  
function setSharingHeader(data: IProduct[], link: string) {
  // Sharing
  if (link.match("./p/")) {
    const pattern: string = "/p/";
    const id: string = link.substr(link.indexOf(pattern) + 3);
    const product: IProduct = getProduct(data, id);
    if (product !== null) {
      const sharingString: string = getSharingString(
        product,
        link.substr(link.indexOf(pattern))
      );
      const bridgeSharing: string = makeBridgeStringObject(
        "sharing",
        sharingString
      );
      return (
        <Helmet>
          <script>{bridgeSharing}</script>
        </Helmet>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}

function setTitleHeader(data: IProduct[], link: string) {
  // Title
  let titleString: string = "Digital Excellence";
  let bridgeTitle: string = "";

  if (link.match("./p/")) {
    // Product name
    const pattern: string = "/p/";
    const id: string = link.substr(link.indexOf(pattern) + 3);
    const product = getProduct(data, id);
    if (product !== null) {
      titleString = product.name;
    }
  } else if (link.match("/products")) {
    // All Products
    titleString = "All Products";
  } else if (link.match("/search")) {
    titleString = "Search Results";
  } else if (link.match("/woman")) {
    titleString = "Women's Fashion";
  } else if (link.match("/man")) {
    titleString = "Men's Fashion";
  }

  bridgeTitle = makeBridgeString("title", titleString);
  return (
    <Helmet>
      <script>{bridgeTitle}</script>
    </Helmet>
  );
}

function getProduct(products: IProduct[], id: any): IProduct {
  let res: any = null;
  products.forEach((product: IProduct) => {
    if (product.id === id) {
      res = product;
    }
  });
  return res;
}  






// WEBPACK FOOTER //
// ./src/App.tsx